import { FCC } from "@/types/common";
import { TCompanyForm } from "@/features/company/types/CompanyForm";
import { Grid } from "@mui/material";
import { CompanyInfoItem } from "@/features/company/components/company-detail/CompanyInfoItem";
import React from "react";
import { InnerBox } from "@/components/elements/InnerBox";
import { CompanyFormTitle } from "@/features/company/components/company-info/CompanyFormTitle";
import { secondary } from "@/theme/colors";
import { CompanyFileItem } from "@/features/company/components/company-detail/CompanyFileItem";

type TCompanyContractInfoProps = {
  defaultValues: Partial<TCompanyForm>;
};

export const CompanyContractInfo: FCC<TCompanyContractInfoProps> = ({ defaultValues }) => {
  const extensionShowPreview = ["jpg", "png", "jpeg", "pdf"];
  const getExtension = (fileName: string) => fileName.split(".").pop()?.trim().toLowerCase();

  const isPreview = (fileName: string) => {
    const ext = getExtension(fileName);
    return !!ext && extensionShowPreview.includes(ext);
  };

  const imagePaths = defaultValues.contractPaths?.filter((item) => isPreview(item)) ?? [];

  const indexImage = (path: string): number => {
    if (!imagePaths || imagePaths.length === 0) return -1;
    return imagePaths.findIndex((item) => item === path);
  };
  return (
    <InnerBox title={<CompanyFormTitle text="基本契約書" />} showDivider={false}>
      <Grid
        container
        sx={{
          marginTop: "8px",
        }}
        spacing={3}
      >
        <Grid item xs={12}>
          <CompanyInfoItem
            label="契約書URL"
            color={defaultValues?.contractUrl ? secondary[80] : ""}
            value={defaultValues?.contractUrl}
            isShowDivider={false}
            type="link"
          />
        </Grid>
        <Grid item xs={12}>
          {defaultValues?.contractPaths &&
            defaultValues?.contractPaths.map((path, idx) => (
              <CompanyFileItem
                key={idx}
                currentFileIndex={indexImage(path)}
                enableFileSize={false}
                filePath={path}
                imagePaths={imagePaths ?? []}
                downloadable
                previewEnabled={isPreview(path)}
              />
            ))}
        </Grid>
      </Grid>
    </InnerBox>
  );
};
